module.exports = __webpack_public_path__ + "static/minigator-2f2e99e3bf7453ae34b17be11102bfbe.png";